import { Button } from '@/components/base/button';
import { useAccount } from '@/state/account';
import { cn } from '@/lib/utils';

export function NetworkToggle() {
  const { network, setNetwork } = useAccount();
  return (
    <div className="para:inline-flex para:rounded-md para:border para:border-border para:bg-muted para:p-1">
      {(['mainnet', 'devnet'] as const).map((n) => (
        <Button
          key={n}
          variant={network === n ? 'default' : 'ghost'}
          size="sm"
          onClick={() => setNetwork(n)}
          className={cn('para:capitalize', network !== n && 'para:text-muted-foreground')}
        >
          {n}
        </Button>
      ))}
    </div>
  );
}
